<script>
	import { push } from "svelte-spa-router";
	import CookbookService from "../server/service/CookbookService";
    import PagedContent from "../components/PagedContent.svelte";
    
    function gotoNewCookbook() {
        push('/cookbooks/new');
    }
</script>

<style>
</style>

<h1>Cookbooks</h1>
<button type="button" on:click|preventDefault={gotoNewCookbook}>New</button>

<PagedContent service={CookbookService} route="/cookbooks/" />
